import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BrainIcon } from 'lucide-react';
import QuizExitPopup from './QuizExitPopup';
const questions = [{
  id: 1,
  text: 'Hur ofta glömmer du var du lagt vardagliga saker som nycklar eller telefon?',
  options: ['Nästan aldrig', 'Någon gång i månaden', 'Någon gång i veckan', 'Nästan dagligen']
}, {
  id: 2,
  text: 'Hur ofta har du svårt att komma ihåg namn på personer du nyligen träffat?',
  options: ['Nästan aldrig', 'Ibland, men det är inte ett problem', 'Ofta, det börjar bli besvärligt', 'Mycket ofta, det är frustrerande']
}, {
  id: 3,
  text: 'Hur ofta tappar du tråden mitt i en konversation?',
  options: ['Nästan aldrig', 'Ibland när jag är trött', 'Ganska ofta', 'Regelbundet, det påverkar mina samtal']
}, {
  id: 4,
  text: 'Hur skulle du beskriva ditt minne jämfört med för 5-10 år sedan?',
  options: ['Bättre än förr', 'Ungefär detsamma', 'Något sämre', 'Märkbart sämre']
}, {
  id: 5,
  text: 'Hur ofta måste du läsa samma text flera gånger för att förstå innehållet?',
  options: ['Sällan eller aldrig', 'Ibland', 'Ganska ofta', 'Mycket ofta']
}];
const QuizQuestion = ({
  answers,
  setAnswers
}) => {
  const {
    questionId
  } = useParams();
  const navigate = useNavigate();
  const currentQuestionId = parseInt(questionId);
  const question = questions.find(q => q.id === currentQuestionId);
  const [selectedOption, setSelectedOption] = useState(answers[currentQuestionId] || null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showExitPopup, setShowExitPopup] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    // Set selected option based on any previous answer
    setSelectedOption(answers[currentQuestionId] || null);
    // Exit intent detection
    const handleMouseLeave = e => {
      if (e.clientY <= 0 && !showExitPopup) {
        setShowExitPopup(true);
      }
    };
    // Add exit intent detection
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [currentQuestionId, answers, showExitPopup]);
  const handleOptionSelect = option => {
    setSelectedOption(option);
    // Auto-advance to next question after a short delay
    setTimeout(() => {
      if (option) {
        setIsSubmitting(true);
        // Save the answer
        setAnswers({
          ...answers,
          [currentQuestionId]: option
        });
        // Navigate to next question or loading screen
        setTimeout(() => {
          setIsSubmitting(false);
          if (currentQuestionId < questions.length) {
            navigate(`/quiz/${currentQuestionId + 1}`);
          } else {
            // Go to loading screen instead of directly to results
            navigate('/loading');
          }
        }, 300);
      }
    }, 500);
  };
  const handleNext = () => {
    if (selectedOption) {
      setIsSubmitting(true);
      // Save the answer
      setAnswers({
        ...answers,
        [currentQuestionId]: selectedOption
      });
      // Navigate to next question or loading screen
      setTimeout(() => {
        setIsSubmitting(false);
        if (currentQuestionId < questions.length) {
          navigate(`/quiz/${currentQuestionId + 1}`);
        } else {
          // Go to loading screen instead of directly to results
          navigate('/loading');
        }
      }, 500);
    }
  };
  const handleContinueQuiz = () => {
    setShowExitPopup(false);
  };
  if (!question) {
    return <div data-id="element-158">Frågan hittades inte</div>;
  }
  const progress = currentQuestionId / questions.length * 100;
  return <div className="container mx-auto px-4 py-8" data-id="element-159">
      <QuizExitPopup isVisible={showExitPopup} onClose={() => setShowExitPopup(false)} onContinue={handleContinueQuiz} data-id="element-160" />
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-6 md:p-8" data-id="element-161">
        <div className="mb-6" data-id="element-162">
          <p className="text-sm text-blue-600 italic mb-2 text-center" data-id="element-163">
            Forskningen visar att de flesta blir förvånade över sina resultat...
          </p>
          <div className="flex justify-between items-center mb-2" data-id="element-164">
            <span className="text-sm font-medium text-gray-500" data-id="element-165">
              Fråga {currentQuestionId} av {questions.length}
            </span>
            <span className="text-sm font-medium text-blue-600" data-id="element-166">
              {Math.round(progress)}% klart
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-167">
            <div className="bg-blue-600 h-2.5 rounded-full transition-all duration-300" style={{
            width: `${progress}%`
          }} data-id="element-168"></div>
          </div>
        </div>
        <div className="flex justify-center mb-6" data-id="element-169">
          <BrainIcon className="h-12 w-12 text-blue-600" data-id="element-170" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mb-6 text-center" data-id="element-171">
          {question.text}
        </h2>
        <div className="space-y-3 mb-8" data-id="element-172">
          {question.options.map((option, index) => <div key={index} onClick={() => handleOptionSelect(option)} className={`p-4 border rounded-lg cursor-pointer transition-all ${selectedOption === option ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-blue-300'}`} data-id="element-173">
              <div className="flex items-center" data-id="element-174">
                <div className={`w-5 h-5 rounded-full border flex-shrink-0 mr-3 ${selectedOption === option ? 'border-blue-500 bg-blue-500' : 'border-gray-400'}`} data-id="element-175">
                  {selectedOption === option && <span className="flex items-center justify-center h-full text-white" data-id="element-176">
                      ✓
                    </span>}
                </div>
                <span className={`${selectedOption === option ? 'text-blue-700 font-medium' : 'text-gray-700'}`} data-id="element-177">
                  {option}
                </span>
              </div>
            </div>)}
        </div>
        <button onClick={handleNext} disabled={!selectedOption || isSubmitting} className={`w-full py-3 px-6 rounded-lg text-white font-bold transition duration-300 ${!selectedOption ? 'bg-gray-400 cursor-not-allowed' : isSubmitting ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'}`} data-id="element-178">
          {isSubmitting ? 'Bearbetar...' : currentQuestionId < questions.length ? `Nästa Fråga (${currentQuestionId + 1}/${questions.length})` : 'Visa Mina Resultat'}
        </button>
      </div>
    </div>;
};
export default QuizQuestion;